export const environment = {
  appname: 'Lace & Liora',
  host: 'https://laceliora.com',
  ig: 'https://www.instagram.com/lace.liora',
  email: 'support@laceliora.com',
  address1: '1101 S York St',
  address2: 'Denver, CO 80210',
  free_shipping_threshold: 300,
  collection: {
    new_arrivals: 'new-arrivals',
    best_sellers: 'best-sellers',
  },
  social_media: {
    ig: 'https://www.instagram.com/lace.liora',
    facebook: 'https://www.facebook.com/profile.php?id=61590592563573'
  },
  api: {
    host: 'https://laceliora.com/api',
    s3endpoint: 'https://storage.laceliora.com',
  },
  google: {
    reCaptcha: {
      siteKey: '6Lcvg8UsAAAAAG0hCp4JTAEGNIghcXc9anGZqv9V',
    },
    oauth: {
      clientID:
        '642873476515-cigc9msremidno1ncrb1bpptqgg8js0t.apps.googleusercontent.com',
    },
    api: {
      place: 'AIzaSyCL2N48eT0s1oeO4d5SKi3WBTLUlvEtKXM',
    },
  },
  stripe: {
    apikey:
      'pk_live_51TfbLsPQApbGV04TymaUUfZPAwgP60lgsmYxZNuKVDmsGFFvGdmoDsic8vMQ3ijAabRXybC13Mc9WSIh2aY6diWS00dHtsvv99',
  },
};
